<template>
    <div class="common__page__box" style="padding: 0;">
        <div class="rlms-container">
            <div class="all-wrapper">
                <aside class="sidebar-wrapper">
                    <RouterLink to="/organizations" class="sidebar-head">
                        <img :src="SidebarIcon" width="24" height="24" alt="">
                        <span class="rlms-fw-600">Back</span>
                    </RouterLink>

                    <div class="rlms-stroke"></div>

                    <div class="sidebar-body">
                        <ul class="sidebar-pages">
                            <template v-for="(item, i) in sidebarLinks" :key="i">
                                <li :class="{ 'active': isActive(item.to) }"
                                    v-if="(organization?.is_owner || organization?.is_administrator) || item.condition && item?.condition(organization?.permissions)">
                                    <RouterLink :to="item.to"
                                        :class="{ 'link-active': isActive(item.to) || item?.childRouteNames?.includes($route.name) }"
                                        v-if="!item?.hide">
                                        <div class="sp-li-item">
                                            <div class="sp-icon">
                                                <img :src="`${item.icon}`" width="24" height="24" alt="">
                                            </div>
                                            <p class="rlms-fw-500 rlms-us-none">{{ item.name }}</p>
                                        </div>
                                    </RouterLink>
                                </li>
                            </template>
                        </ul>
                    </div>
                </aside>

                <div class="all-content">
                    <div class="all-content-inner rlms-height-full rlms-bg-white rlms-py-desk50-mob-30">
                        <div class="rlms-container-sm">
                            <div class="rlms-flex rlms-flex-col rlms-gap-20">
                                <div class="pages-topbar">
                                    <div class="pages-topbar-body">
                                        <div class="scrollable-container">
                                            <div class="pages-topbar-head rlms-mb-5">
                                                <RouterLink to="/organizations" class="sidebar-head">
                                                    <img :src="SidebarIcon" width="24" height="24" alt="">
                                                    <span class="rlms-fw-600">Back</span>
                                                </RouterLink>
                                            </div>
                                            <div class="scrollable-content">
                                                <ul>
                                                    <template v-for="(item, i) in sidebarLinks" :key="i">
                                                        <li :class="{ 'active': isActive(item.to) }"
                                                            v-if="(organization?.is_owner || organization?.is_administrator) || item.condition && item?.condition(organization?.permissions)">
                                                            <RouterLink :to="item.to"
                                                                :class="{ 'link-active': isActive(item.to) }"
                                                                v-if="!item?.hide">
                                                                <div class="pages-topbar-link-icon"
                                                                    style="width: 24px;">
                                                                    <img :src="`${item.icon}`" width="24" height="24"
                                                                        alt="">
                                                                </div>
                                                                <p class="rlms-fw-500 rlms-us-none">{{ item.name }}
                                                                </p>
                                                            </RouterLink>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <router-view></router-view>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import SidebarIcon from '@/assets/images/sidebar_blade_32b18715.svg'
import OverviewIcon from '@/assets/images/sidebar_blade_88bcc66a.svg'
import LearnersIcon from '@/assets/images/sidebar_blade_15c402e2.svg'
import AdminsIcon from '@/assets/images/sidebar_blade_6ff6c32a.svg'
import GroupsIcon from '@/assets/images/sidebar_blade_8ce6fbe5.svg'
import ProductsIcon from '@/assets/images/sidebar_blade_e9bc3e41.svg'
import PurchaseIcon from '@/assets/images/sidebar_blade_30265a60.svg'
import AgreementIcon from '@/assets/images/organization-agreements.svg'

import { useRoute, RouterLink } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useLoaderStore } from '@/stores/loader'
import api from '@/services/axios'
import { handleError } from '@/utils/handleError'
import { authrizedPermissions } from '@/utils/permissions'

const route = useRoute()

const organizationId = route.params.organization;

// Define links with icons
const sidebarLinks = [
    {
        name: 'Overview',
        icon: OverviewIcon,
        to: `/organizations/${organizationId}/overview`,
    },
    {
        name: 'Learners',
        icon: LearnersIcon,
        to: `/organizations/${organizationId}/learners`,
        childRouteNames: ['LearnerDetail'],
        condition: (permissions) => permissions && (permissions?.[authrizedPermissions.view_assessments] || permissions?.[authrizedPermissions.conduct_view_assessments]),
    },
    {
        name: 'Administrators',
        icon: AdminsIcon,
        to: `/organizations/${organizationId}/administrator`,
    },
    {
        name: 'Groups',
        icon: GroupsIcon,
        to: `/organizations/${organizationId}/group`,
        childRouteNames: ['OrgGroupDetail']
    },
    {
        name: 'Products',
        icon: ProductsIcon,
        to: `/organizations/${organizationId}/subscription`,
        childRouteNames: ['OrgCart'],
    },
    {
        name: 'Purchase History',
        icon: PurchaseIcon,
        to: `/organizations/${organizationId}/subscription/purchase-history`,
    },
    {
        name: 'Agreements',
        icon: AgreementIcon,
        to: `/organizations/${organizationId}/agreements`,
        condition: (permissions) => permissions && (permissions?.[authrizedPermissions.view_assessments] || permissions?.[authrizedPermissions.conduct_view_assessments])
    },
]

const isActive = (path) => {
    return route.path === path
}

const loader = useLoaderStore();

const organization = ref([]);

onMounted(async () => {
    fetchOrganization();
});

const fetchOrganization = async () => {
    try {
        loader.show();

        const { data } = await api.get(`/organizations/${organizationId}`);

        organization.value = data.data;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}
</script>